<template>
  <div class="detail-item-base">
    <h3
      @click="onHeadClick"
      :class="{open: panelOpen, 'panel-ctrl': isPanelCtrl}"
      v-if="!noHead"
    >
      <span class="datetime">{{dayInfo.datetime | dateStr}}</span>
      <span class="stars">
        <img
          src="/static/img/recommend/lp/kurenotori/products/biorhythm_star.svg"
          alt=""
          v-for="n of starsNum"
          :key="`star${n}`"
        >
      </span>
      <span class="head-arrow" v-if="isPanelCtrl"><span></span></span>
    </h3>
    <p class="description" v-if="!isPanelCtrl" v-html="dayDescription"></p>
  </div>
</template>

<script>
import moment from 'moment'
moment.locale('ja')

export default {
  name: 'BiorhythmDetailItem',
  props: {
    dayInfo: {
      type: Object,
    },
    panelOpen: {
      type: Boolean,
      default: false,
    },
    isPanelCtrl: {
      type: Boolean,
      default: false,
    },
    noHead: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    starsNum() {
      return !!this.dayInfo.text2 ? this.dayInfo.text2.length : 2
    },
    dayDescription() {
      // return `${!!this.dayInfo.text2 && this.dayInfo.text2.length > 0 ? this.dayInfo.text2 + '<br>' : ''}${this.dayInfo.text3}`
      return `${this.dayInfo.text3}`
    },
  },
  methods: {
    onHeadClick() {
      this.$emit('panel-ctrl-click')
    }
  },
  filters: {
    dateStr(val) {
      const m = new moment(val)
      if(!!m) {
        return m.format('MM.DD (ddd)')
      }
      return ''
    }
  }
}</script>

<style scoped lang="scss">
h3 {
  background: #e3f7f9;
  width: 100%;
  color: var(--key-color);
  margin: 0;
  padding: 8px 8px;
  position: relative;
  .stars {
    display: inline-block;
    img {
      display: inline-block;
      width: 0.9em;
      line-height: 1;
      vertical-align: text-bottom;
    }
  }
  .head-arrow {
    width: 11px;
    height: 11px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 14px;
    margin: auto;
    display: block;
    padding: 2px;
    box-sizing: content-box;
    & > span {
      width: 100%;
      height: 100%;
      position: relative;
      display: block;
      transition: all 200ms ease-out 0s;
      &::before,
      &::after {
        content: "";
        display: block;
        background: var(--key-color);
        border-radius: 2px;
        height: 2px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      &::before {
        transform: translate(-4px, 0) rotate(45deg);
      }
      &::after {
        transform: translate(3px, 0) rotate(-45deg);
      }
    }
  }
  &.open {
    .head-arrow {
      & > span {
        transform: rotate(180deg);
      }
    }
  }
}
.description {
  margin: 0;
  padding: 8px 0 16px;
  font-size: 14px;
  line-height: 22px;
  color: #32373f;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/partials/BiorhythmDetailItem.vue